import React from 'react'

import { User, CirclePercent, Star } from 'lucide-react'

interface MetricDisplayProps {
  dataPoints: number
  /**
   * Percentage value represented as an integer with no decimal places.
   * This should already be rounded appropriately by the calling component.
   */
  percentage: number
  /**
   * Count of VIP sessions related to the datapoints. When greater than 0 a
   * star + number is rendered before the unique datapoints indicator.
   */
  vipCount?: number
  variant?: 'default' | 'compact'
}

const MetricDisplay = ({ dataPoints, percentage, vipCount = 0, variant = 'default' }: MetricDisplayProps) => {
  if (variant === 'compact') {
    return (
      <div className="flex items-center gap-6">
        {vipCount > 0 && (
          <div className="flex items-center gap-1.5">
            <Star className="w-3.5 h-3.5 text-[#FF4A8E]" fill="currentColor" />
            <span className="font-manrope text-xs font-medium text-[#FF4A8E]">{vipCount} VIP</span>
          </div>
        )}
        <div className="flex items-center gap-1.5">
          <User className="w-3.5 h-3.5 text-[#FF4A8E]" />
          <span className="font-manrope text-xs font-medium text-[#FF4A8E]">{dataPoints} sessions</span>
        </div>
        <div className="flex items-center gap-1.5">
          <CirclePercent className="w-3.5 h-3.5 text-[#40424A] dark:text-gray-300" />
          <span className="font-manrope text-xs font-medium text-[#40424A] dark:text-gray-300">
            {percentage}% of total
          </span>
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-4">
      {vipCount > 0 && (
        <div className="flex items-center gap-1.5">
          <Star className="w-4 h-4 text-[#FF4A8E]" fill="currentColor" />
          <span className="font-manrope text-sm font-medium text-[#FF4A8E]">{vipCount} VIP</span>
        </div>
      )}
      <div className="flex items-center gap-1.5">
        <User className="w-4 h-4 text-[#FF4A8E]" />
        <span className="font-manrope text-sm font-medium text-[#FF4A8E]">{dataPoints} sessions</span>
      </div>
      <div className="flex items-center gap-1.5">
        <CirclePercent className="w-4 h-4 text-[#40424A] dark:text-gray-300" />
        <span className="font-manrope text-sm font-medium text-[#40424A] dark:text-gray-300">
          {percentage}% of total
        </span>
      </div>
    </div>
  )
}

export default MetricDisplay
